import { useCloseModal } from '@/atoms'
import { FormActionButton } from '@workwave-tidal/core/form'
import { form } from './formState'
import { useTexts } from '../hooks/useTexts'

export function FormFooter() {
  const close = useCloseModal()
  const texts = useTexts()
  const {
    meta: { submitting, validating, status },
  } = form.useFormMeta()

  const saveDisabled = status === 'pristine' || validating || submitting

  return (
    <>
      <FormActionButton
        label={texts.footer.cancel}
        size="medium"
        onClick={close}
        testId="modal-secondary-button"
        data-trackid="modal__button-cancel"
      />
      <FormActionButton
        label={texts.footer.update}
        size="medium"
        variant="contained"
        type="submit"
        disabled={saveDisabled}
        testId="modal-primary-button"
        data-trackid="modal__button-update"
        loading={submitting}
      />
    </>
  )
}
